import { render, staticRenderFns } from "./AddMedia.vue?vue&type=template&id=f00c5d70&scoped=true"
import script from "./AddMedia.vue?vue&type=script&lang=js"
export * from "./AddMedia.vue?vue&type=script&lang=js"
import style0 from "./AddMedia.vue?vue&type=style&index=0&id=f00c5d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00c5d70",
  null
  
)

export default component.exports